loadAtatus();

function loadAtatus()
{
    if(document.querySelector("meta[name=atatus]")) {
        let ID = document.querySelector('meta[name=atatus]').getAttribute('content');
        if (ID === undefined) {
            return;
        }
        if (ID.length) {
            atatus.config(ID).install();
        }
    }
}

function mergeObjects() {
    let resObj = {};
    for(let i=0; i < arguments.length; i += 1) {
        let obj = arguments[i],
            keys = Object.keys(obj);
        for(let j=0; j < keys.length; j += 1) {
            resObj[keys[j]] = obj[keys[j]];
        }
    }
    return resObj;
}

let getCookie = function (name) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
};

function setCookie(name, value, durationSeconds, path = '/') {
    const date = new Date();
    date.setTime(date.getTime() + (durationSeconds * 1000));
    let expires = "expires="+ date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=" + path + '; SameSite=Strict'
}
window.addEventListener('DOMContentLoaded', function (event){
    dataHref();
    loadAnalytics();
    instantSearch();
})
function loadAnalytics() {
    let ID = document.querySelector('meta[name=analytics]').getAttribute('content');
    if(ID === undefined)
    {
        return;
    }
    if(ID.length)
    {
        if(ID.substring(0,3).toLowerCase() === 'ua-') {
            (function (i, s, o, g, r, a, m) {
                i['GoogleAnalyticsObject'] = r;
                i[r] = i[r] || function () {
                    (i[r].q = i[r].q || []).push(arguments)
                }, i[r].l = 1 * new Date();
                a = s.createElement(o),
                    m = s.getElementsByTagName(o)[0];
                a.async = 1;
                a.src = g;
                m.parentNode.insertBefore(a, m)
            })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

            ga('create', ID, 'auto');
            ga('send', 'pageview');
        }
        else if (ID.substring(0,2).toLowerCase() === 'g-')
        {
            let script = document.createElement("script");
            script.src = "https://www.googletagmanager.com/gtag/js?id="+ID;
            script.onload = function () {
                window.dataLayer = window.dataLayer || [];
                function gtag(){window.dataLayer.push(arguments);}
                gtag('js', new Date());

                gtag('config', ID);
            }
            document.head.appendChild(script);
        }
    }


}
function dataHref() {
    Array.from(document.querySelectorAll('[data-href]') ?? []).forEach(function (element) {
        element.addEventListener('click', function (event){
            event.preventDefault();
            window.open(element.getAttribute('data-href'));
        });
    });
}

/**
 * TODO: handle trailing slash
 */
function instantSearch()
{
    let searchFieldEl = document.getElementById('instantSearchField');
    let resultsEl = document.getElementById('instantSearchResults');

    if(searchFieldEl === null || resultsEl === null)
    {
        return;
    }

    let ajaxUrl = searchFieldEl.getAttribute('data-instantUrl');
    if (ajaxUrl === null){
        return;
    }

    let params = [];

    let config = resultsEl.getAttribute('data-params');
    if (!config){
        let resultTemplate = document.getElementById('instantSearchResult');
        if(!resultTemplate){
            return;
        }
        resultTemplate = resultTemplate.innerHTML;
        resultTemplate = resultTemplate.replaceAll('templatelink', 'a');
        params.push(
            {
                node: null,
                container: resultsEl,
                template: resultTemplate,
            }
        )
    } else {
        config.split(',').forEach(function (line){
            line = line.split('|');
            if(line.length < 3){
                return
            }

            let container = document.getElementById(line[1])
            if(!container){ return }

            let template = document.getElementById(line[2]);
            if(!template){ return }
            template = template.innerHTML;
            template = template.replaceAll('templatelink', 'a');
            if(template.length < 1) { return }

            params.push({
                node: line[0],
                container: container,
                template: template,
            })
        });
    }

    let timer = 0;

    searchFieldEl.addEventListener('keyup', function (event) {
        clearTimeout(timer);
        resultsEl.style.setProperty('display', 'none');
        let term = searchFieldEl.value;
        if(term.length < (searchFieldEl.getAttribute('data-minTerm') ?? 1)) {
            return;
        }

        timer = setTimeout(function () {
            let xhr = new XMLHttpRequest();
            xhr.open("POST", ajaxUrl, true);

            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

            xhr.onload = function() {
                if(term !== searchFieldEl.value || !this.responseText){
                    return;
                }
                let data = JSON.parse(this.responseText);
                let hasItems = false;


                params.forEach(function (param){
                    param.container.innerHTML = '';
                    let items = param.node === null ? data : data[param.node]
                    if(items.length > 0) {
                        hasItems = true;

                        items.forEach(function (item) {
                            let template = document.createElement('template');

                            let html = param.template;
                            for (const [key, value] of Object.entries(item)) {
                                html = html.replaceAll('{' + key + '}', (value ?? ''));
                            }

                            template.innerHTML = html;
                            if (item.dropElements) {
                                item.dropElements.forEach(function (item) {
                                    let elem = template.content.querySelector('.' + item);

                                    if (elem)
                                        elem.parentNode.removeChild(elem);
                                });
                            }
                            param.container.appendChild(template.content);
                        });
                    }
                });

                hasItems
                    ? resultsEl.style.removeProperty('display')
                    : resultsEl.style.setProperty('display', 'none');
            }

            xhr.send('term='+encodeURIComponent(term));
        }, 200);
    });
}

function adbCheck(callback) {
    let url = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
    let xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            callback(xhr.status === 0 || xhr.responseURL !== url);
        }
    };
    xhr.open('HEAD', url, true);
    xhr.send(null);
}

window.addEventListener('DOMContentLoaded', function (event){
    document.paginationQuery = [];

    if (document.getElementById('pager-infinite')) {
        document.nextUrl = document.getElementById('pager-infinite').getAttribute('data-next-url');
        document.previousUrl = document.getElementById('pager-infinite').getAttribute('data-previous-url');

        let last_scroll = window.scrollY;

        function addScrollListener() {
            document.infiniteScroll = true;
            window.addEventListener('scroll', function () {
                // handle scroll events to update content
                let scroll_pos = window.scrollY;

                // Adjust the URL based on the top item shown
                // for reasonable amounts of items
                if (Math.abs(scroll_pos - last_scroll) > window.innerHeight * 0.1) {
                    let pagesContent = document.getElementById('pages-content');
                    let windowTop = window.scrollY;
                    let windowBottom = window.scrollY + window.innerHeight;
                    let elementTop = pagesContent.offsetTop;
                    let elementBottom = pagesContent.offsetTop + pagesContent.offsetHeight;

                    if (elementTop < windowBottom && elementTop > windowTop) {
                        loadPrevious();
                    }

                    if (elementBottom < windowBottom && elementBottom > windowTop) {
                        loadNext();
                    }

                    last_scroll = scroll_pos;
                    let maxIntersection = 0;
                    let topElement = null;
                    Array.from(document.getElementsByClassName('page-content')).forEach(function (element) {
                        let intersection = calculateIntersection(element);
                        if (intersection > maxIntersection) {
                            maxIntersection = intersection;
                            topElement = element;
                        }
                    });

                    if (topElement && document.getElementById('pager-infinite').getAttribute('data-state') !== "false" ) {
                        history.replaceState(null, '', topElement.getAttribute('data-url'));
                    }
                }
            });
        }
        let loadMore = document.getElementById("page-load-more");

        if (loadMore) {
            loadMore.addEventListener('click', function () {
                loadNext();
                addScrollListener();
                loadMore.style.display = 'none';
            });
        } else {
            addScrollListener();
        }
    }

    if (document.getElementsByClassName("pagination-param")) {
        Array.from(document.getElementsByClassName("pagination-param")).forEach(function (element) {
            element.addEventListener('change', function () {
                document.paginationQuery[element.getAttribute('name')] = element.value;
                reload();
            });
        });
    }
});

function calculateIntersection(element) {
    return Math.min(window.scrollY + window.innerHeight, element.offsetTop + element.offsetHeight) - Math.max(window.scrollY, element.offsetTop);
}

function reload() {

    if (document.pageLoading){
        setTimeout(this.reload, 100)
        return;
    }

    let loadMore = document.getElementById("page-load-more");
    if(loadMore) {
        loadMore.style.display = 'none';
    }

    document.querySelector('#pages-content').textContent = '';

    if (document.getElementById("page-loading-previous"))
        document.getElementById("page-loading-previous").style.removeProperty('display');

    ajaxTemplate(window.location.href, function(data, pageElement){
        if (data && pageElement) {
            document.getElementById('pages-content').appendChild(pageElement);

            document.previousUrl = data.previousUrl;
            document.nextUrl = data.nextUrl;

            if(loadMore && data.nextUrl && !document.infiniteScroll) {
                loadMore.style.removeProperty('display');
            }
        }

        if (document.getElementById("page-loading-previous"))
            document.getElementById("page-loading-previous").style.display = 'none';
    });
}

function loadPrevious() {
    if (!document.previousUrl || document.pageLoading)
        return;

    if (document.getElementById("page-loading-previous"))
        document.getElementById("page-loading-previous").style.removeProperty('display');

    ajaxTemplate(document.previousUrl, function(data, pageElement){
        if (data && pageElement) {
            document.getElementById('pages-content').prepend(pageElement);

            document.previousUrl = data.previousUrl;
            document.currentUrl = data.currentUrl;

            setTimeout(function () {
                window.scrollTo(null, window.scrollY + pageElement.offsetHeight);
            }, 3);
        }

        if (document.getElementById("page-loading-previous"))
            document.getElementById("page-loading-previous").style.display = 'none';
    });
}

function loadNext() {
    if (!document.nextUrl || document.pageLoading)
        return;

    if (document.getElementById("page-loading-next"))
        document.getElementById("page-loading-next").style.removeProperty('display');

    ajaxTemplate(document.nextUrl, function(data, pageElement){
        if (data && pageElement) {
            document.getElementById('pages-content').appendChild(pageElement);
            document.nextUrl = data.nextUrl;
            document.currentUrl = data.currentUrl;
        }

        if (document.getElementById("page-loading-next"))
            document.getElementById("page-loading-next").style.display = 'none';
    });
}

function ajaxTemplate(url, callback) {
    document.pageLoading = true;

    url = new URL(url, url.indexOf("://") !== -1 ? undefined : document.baseURI);

    if (url.searchParams.has('type'))
        url.searchParams.set('type', 'json');
    else
        url.searchParams.append('type', 'json');

    if (document.paginationQuery) {
        for (const [key, value] of Object.entries(document.paginationQuery)) {
            if (url.searchParams.has(key)) {
                url.searchParams.set(key, value);
            }
            else {
                url.searchParams.append(key, value);
            }
        }
    }

    let xhr = new XMLHttpRequest();

    xhr.open('GET', url.toString());
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onload = function() {
        if (xhr.status === 200) {
            let data = JSON.parse(xhr.responseText);

            if(data.hasOwnProperty('pageData'))
            {
                for (const [key, value] of Object.entries(data.pageData)) {
                    Array.from(document.getElementsByClassName("page-data-" + key)).forEach(function (element) {
                        element.innerHTML = value;
                    });
                }
            }

            if (data.hasOwnProperty('items')) {
                let pagerState = document.createElement("div");

                pagerState.setAttribute('data-url', data.currentUrl);
                pagerState.setAttribute('class', 'page-content');

                data.items.forEach(function (item) {
                    let template = document.createElement('template');
                    let html = document.getElementById('page-item').innerHTML;

                    for (const [key, value] of Object.entries(item)) {
                        html = html.replaceAll('{' + key + '}', value);
                    }

                    html = html.replaceAll('templatelink', 'a');

                    template.innerHTML = html;

                    if (item.dropElements) {
                        item.dropElements.forEach(function (item) {
                            let elem = template.content.querySelector('.' + item);

                            if (elem)
                                elem.parentNode.removeChild(elem);
                        });
                    }
                    pagerState.appendChild(template.content);
                });

                callback(data, pagerState);
            }
        }
        document.pageLoading = false;
        callback(null, null);
    };
    xhr.send();
}

window.addEventListener('DOMContentLoaded', function () {
    darkModeSwitcher();
    bindMenuButton();
});

function darkModeSwitcher()
{
    Array.from(document.getElementsByClassName('theme-toggle')).forEach(function (element){
        element.addEventListener('click', function () {
            document.documentElement.classList.toggle('dark');
            setCookie('alt-theme', document.documentElement.classList.contains('dark') ? 1 : 0,31536000)
        });
    })
}

function bindMenuButton()
{
    Array.from(document.getElementsByClassName('menu-toggle')).forEach(function (element){
        element.addEventListener('click', function (){
            document.body.classList.toggle('menu-open');
        });
    })
}

